import React, { useState, useEffect } from 'react';
import { osName } from 'react-device-detect';
import FloatingWhatsApp from 'react-floating-whatsapp'

import LandingSection from '../components/LandingSection';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import ServiceSection from '../components/ServiceSection';
import { sectionObjOne } from '../components/ServiceSection/Data';

import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

import avatar from "../img/avatar.webp";




const Home = () => {

    const [isOpen, setIsOpen] = useState(false);
    const [isLandscape, setisLandscape] = useState(false);
    const [fixLandscape, setfixLandscape] = useState(false)
    const [Screen, setScreen] = useState();
    const [scrollNav, setScrollNav] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    const changeNav = () => {
        if (window.scrollY > 110) {
            setScrollNav(true);
        } if (window.scrollY < 90) {
            setScrollNav(false);
        }
    }

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            window.addEventListener('scroll', changeNav)
        }
        return () => isSubscribed = false;
    }, [])

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            window.addEventListener("orientationchange", function() {
                // `this` is now pointing to `window`, not the component. So use `self`.
                setScreenOrientation(this.screen.height, this.screen.width);
                
            }, false);
        }
        return () => isSubscribed = false;
    }, [])


    const setScreenOrientation = (height, width) => {
        if(width > height){
            setfixLandscape(true);
            
            if(width > 767){
                setisLandscape(true);
            }else{
                setisLandscape(false);
            }
        }else{
            setisLandscape(false);
            setfixLandscape(false);

        }

        setScreen({height: height, width: width});
      }
    

    return (
        <>
                <div style={styles.cover}>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} isScroll={scrollNav} />
             <LandingSection isLandscape={isLandscape} fixLandscape={fixLandscape}/>

            <ServiceSection {...sectionObjOne}/>
            <ContactSection/>
            <Footer/>
           
            <FloatingWhatsApp 
                className={scrollNav? 'whatsAppIcon':'whatsAppIconHide'}
                accountName='Luis Torres' 
                phoneNumber='+16199605293' 
                styles={{zIndex:3}}
                zIndex='3' 
                avatar={avatar}
                /> 
        </div>
    </>
    )
}



const styles = {
    cover: {
        width: '100%',
        maxWidth: '100vw'
    },
    whatsappWindow:{
       // width: '500px !important'
    }
}
export default Home
